import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { transactionKeys } from '../transactionQueryKeys'
import { getRentalPayouts } from '../transactionEndpoints'
import type { RentalPayoutsRange } from '../../types/transactionTypes'

export function useRentalPayoutsQuery(range: MaybeRefOrGetter<RentalPayoutsRange>) {
  return useQuery({
    queryKey: () => transactionKeys.rentalPayouts(toValue(range)),
    queryFn: () => getRentalPayouts(toValue(range)),
  })
}
